import { render, staticRenderFns } from "./TipoStatusList.vue?vue&type=template&id=dfe535ca"
import script from "./TipoStatusList.vue?vue&type=script&lang=js"
export * from "./TipoStatusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports